export const products = [
  {
    id: 1,
    img: "/icons/music.png",
    link: "https://neomusic.netlify.app/",
    code: "https://github.com/shivamvr/MusicPlayer",
    tstack: ["html", "css", "react", "sass", "javascript", "json", "heroku"],
    info: { title: 'Music app', desc: 'An online music player to play ' }
  },
  {
    id: 2,
    img: "/icons/quickcode.png",
    link: "https://quickcode.netlify.app/",
    code: "https://github.com/shivamvr/QuickCode",
    tstack: ["html", "css", "javascript", "json","npm"],
    info: { title: 'Quick code', desc: 'An online code editor' }
  },
  {
    id: 3,
    img: "/icons/insta.png",
    link: "https://likeinstagram.netlify.app/",
    code: "https://github.com/shivamvr/project-instagram",
    tstack: ["html", "css", "react", "sass", "javascript", "json", "heroku", "styled"],
    info: { title: 'Instagram-clone', desc: 'A social media plateform' }
  },
  {
    id: 4,
    img: "/icons/ignite.png",
    link: "https://ignitte.netlify.app/",
    code: "https://github.com/shivamvr/ignite",
    tstack: ["html", "css", "react", "redux", "styled", "javascript", "motion"],
    info: { title: 'Ignite', desc: 'A website for rating and review games' }
  },
  {
    id: 5,
    img: "https://d33wubrfki0l68.cloudfront.net/623a19e3226c6b00089f5590/screenshot_2022-03-22-18-48-16-0000.png",
    link: "https://bloghouse.netlify.app/",
    code: "https://github.com/shivamvr/blog-website",
    tstack: ["html", "css", "react", "sass", "javascript"] ,
    info: { title: 'Blog website', desc: 'A plateform for posting blog' }
  },
  {
    id: 6,
    img: "/icons/keeper.png",
    link: "https://keepite.netlify.app/",
    code: "https://github.com/shivamvr/KeeperApp",
    tstack: ["html", "css", "javascript", 'react'],
    info: { title: 'Keeper app', desc: 'Keeper is a online app for taking notes' }
  }
];
